! function(e) {
	var t = {};

	function r(n) {
		if (t[n]) return t[n].exports;
		var o = t[n] = {
			i: n,
			l: !1,
			exports: {}
		};
		return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports
	}
	r.m = e, r.c = t, r.d = function(e, t, n) {
		r.o(e, t) || Object.defineProperty(e, t, {
			enumerable: !0,
			get: n
		})
	}, r.r = function(e) {
		"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(
			e, Symbol.toStringTag, {
				value: "Module"
			}), Object.defineProperty(e, "__esModule", {
			value: !0
		})
	}, r.t = function(e, t) {
		if (1 & t && (e = r(e)), 8 & t) return e;
		if (4 & t && "object" == typeof e && e && e.__esModule) return e;
		var n = Object.create(null);
		if (r.r(n), Object.defineProperty(n, "default", {
				enumerable: !0,
				value: e
			}), 2 & t && "string" != typeof e)
			for (var o in e) r.d(n, o, function(t) {
				return e[t]
			}.bind(null, o));
		return n
	}, r.n = function(e) {
		var t = e && e.__esModule ? function() {
			return e.default
		} : function() {
			return e
		};
		return r.d(t, "a", t), t
	}, r.o = function(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t)
	}, r.p = "", r(r.s = 223)
}({
	2: function(e, t, r) {
		"use strict";
		r.r(t);
		const n = {
			// matchMedia: () => window.matchMedia("(min-width: 1024px)"),
			// isDesktop: () => n.matchMedia().matches,
			isDesktop: () => true,
			toggleClasses: (e, t, r) => {
				e.classList.add(t), e.classList.remove(r)
			},
			addScript: e => {
				if (!e) return;
				const t = document.createElement("script");
				t.setAttribute("src", e), document.body.appendChild(t)
			},
			isColorCloseToWhite: e => {
				const t = (e = +("0x" + e.slice(1).replace(e.length < 5 && /./g, "$&$&"))) >>
					16,
					r = e >> 8 & 255,
					n = 255 & e;
				return Math.sqrt(t * t * .299 + r * r * .587 + n * n * .114) > 230
			},
			bindThisInThesesMethods(e, t) {
				for (let r of t) "function" == typeof e[r] ? e[r] = e[r].bind(e) :
					console.warn("笞��� Cannot find method named " + r + " in component " +
						e.tagName.toLowerCase() + " 笞���")
			},
			handleFetchErrors(e) {
				if (!e.ok) throw Error(e.statusText);
				return e
			},
			insertHtmlThatContainsScripts(e, t) {
				const r = (new DOMParser).parseFromString(t, "text/html");
				var n = r.querySelectorAll("script");
				let o = [];
				for (let [e, t] of n.entries()) o[e] = document.createElement("script"),
					t.type && (o[e].type = t.type), t.src && (o[e].src = t.src), t.innerHTML &&
					(o[e].innerHTML = t.innerHTML), t.async && (o[e].async = t.async), t.defer &&
					(o[e].defer = t.defer), t.crossorigin && (o[e].crossorigin = t.crossorigin),
					t.referrerpolicy && (o[e].referrerpolicy = t.referrerpolicy);
				for (let e of n) e.remove();
				for (const t of r.body.children) e.append(t.cloneNode(!0));
				for (let t of o) e.append(t)
			},
			scrollIntoViewIfNeeded(e, t, r) {
				if (void 0 === t) e.getBoundingClientRect().bottom > window.innerHeight &&
					e.scrollIntoView({
						behavior: "smooth",
						block: "end"
					}), e.getBoundingClientRect().top < 0 && e.scrollIntoView({
						behavior: "smooth",
						block: "start"
					});
				else {
					const n = e.getBoundingClientRect().top,
						o = e.getBoundingClientRect().bottom,
						a = t.getBoundingClientRect().top,
						i = t.offsetHeight;
					if (void 0 === r) o > a + i && e.scrollIntoView({
						behavior: "smooth",
						block: "end"
					}), n < a && e.scrollIntoView({
						behavior: "smooth",
						block: "start"
					});
					else {
						if (o > a + i - r.bottom) {
							const n = e.offsetTop + e.offsetHeight,
								o = window.innerHeight - r.bottom;
							t.scrollTo({
								behavior: "smooth",
								top: n - o
							})
						}
						n - r.top < a && t.scrollTo({
							behavior: "smooth",
							top: e.offsetTop - r.top
						})
					}
				}
			},
			stringToHTMLElements(e, t = !0) {
				if (!(e = t ? e.trim() : e)) return null;
				const r = document.createElement("template");
				r.innerHTML = e;
				const n = r.content.children;
				return 1 === n.length ? n[0] : n
			},
			elementIsVisibleInViewport(e, t = !1) {
				const {
					top: r,
					left: n,
					bottom: o,
					right: a
				} = e.getBoundingClientRect(), {
					innerHeight: i,
					innerWidth: l
				} = window;
				return t ? (r > 0 && r < i || o > 0 && o < i) && (n > 0 && n < l || a >
					0 && a < l) : r >= 0 && n >= 0 && o <= i && a <= l
			},
			getFirstScrollableParent(e) {
				const t = /(auto|scroll)/,
					r = (e, t) => null === e.parentNode ? t : r(e.parentNode, t.concat([e])),
					n = (e, t) => getComputedStyle(e, null).getPropertyValue(t),
					o = e => t.test((e => n(e, "overflow") + n(e, "overflow-y") + n(e,
						"overflow-x"))(e));
				return (e => {
					if (!(e instanceof HTMLElement || e instanceof SVGElement)) return;
					const t = r(e.parentNode, []);
					for (let e = 0; e < t.length; e += 1)
						if (o(t[e])) return t[e];
					return document.scrollingElement || document.documentElement
				})(e)
			},
			isOnPlp: () => "action" in document.body.dataset && "Search-Show" ===
				document.body.dataset.action && "querystring" in document.body.dataset &&
				document.body.dataset.querystring.indexOf("cgid=") > -1,
			isOnSearchResultPage: () => "action" in document.body.dataset &&
				"Search-Show" === document.body.dataset.action && "querystring" in
				document.body.dataset && document.body.dataset.querystring.indexOf("q=") >
				-1
		};
		t.default = n
	},
	223: function(e, t, r) {
		"use strict";
		r.r(t);
		var n = r(2);
		! function(e) {
			function t(e) {
				return n.default.isDesktop() ? e.target.parentNode.querySelector(
					".pageDesigner-player") : e.target.parentNode.querySelector(
					".pageDesigner-player-mobile")
			}
			e(".pageDesigner__player__embedContainer video").on("loadedmetadata", (
					function(e) {
						e.preventDefault();
						const r = t(e),
							n = Math.round(r.duration);
						r.parentNode.querySelector(".pageDesigner__player__progressBar").setAttribute(
								"max", n), r.parentNode.querySelector(".pageDesigner__player__seek")
							.setAttribute("max", n)
					})), e(".pageDesigner__player__embedContainer video").on("timeupdate", (
					function(e) {
						e.preventDefault();
						const r = t(e),
							n = Math.floor(e.target.currentTime);
						r.parentNode.querySelector(".pageDesigner__player__progressBar").value =
							n, r.parentNode.querySelector(".pageDesigner__player__seek").value =
							n
					})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__play").on(
					"click", (function(e) {
						e.preventDefault(), e.target.parentNode.classList.toggle("-pause");
						const t = n.default.isDesktop() ? e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player") : e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player-mobile");
						t.paused ? t.play() : t.pause()
					})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__forward").on(
					"click", (function(e) {
						const t = n.default.isDesktop() ? e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player") : e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player-mobile");
						e.preventDefault(), t.currentTime += t.duration / 100 * 5
					})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__muted").on(
					"click", (function(e) {
						const t = n.default.isDesktop() ? e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player") : e.target.closest(
							".pageDesigner__player__embedContainer").querySelector(
							".pageDesigner-player-mobile");
						e.preventDefault(), t.muted ? t.muted = !1 : t.muted = !0, e.target.parentNode.classList.toggle("-soundon");
					})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__fullscreen"
				).on("click", (function(e) {
					let t = e.target.closest(".pageDesigner__player__embedContainer");
					const r = n.default.isDesktop() ? t.querySelector(
						".pageDesigner-player") : t.querySelector(
						".pageDesigner-player-mobile");
					e.preventDefault(), document.fullscreenElement ? document.exitFullscreen() :
						r.requestFullscreen ? t.requestFullscreen() : r.webkitRequestFullScreen ?
						t.webkitRequestFullScreen() : r.webkitEnterFullScreen && (r.webkitEnterFullScreen(),
							t.querySelector(".pageDesigner__player__play").classList.toggle(
								"-pause"), r.play())
				})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__seek").on(
					"click", (function(e) {
						let t = e.target.closest(".pageDesigner__player__embedContainer");
						if (t.querySelectorAll(".pageDesigner__player__forward").length) {
							const r = n.default.isDesktop() ? t.querySelector(
									".pageDesigner-player") : t.querySelector(
									".pageDesigner-player-mobile"),
								o = Math.round(e.offsetX / e.target.clientWidth * parseInt(t.querySelector(
									".pageDesigner__player__progressBar").getAttribute("max"), 10));
							r.currentTime = o, t.querySelector(
								".pageDesigner__player__progressBar").value = o, t.querySelector(
								".pageDesigner__player__seek").value = o
						}
					})), e(
					".pageDesigner__player__embedContainer .pageDesigner__player__controls")
				.on("click", (function(e) {
					e.preventDefault()
				}))
		}(jQuery)
	}
});
